import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '../ui/tooltip';

// 10 basic colors
export const PIECE_COLORS = [
  { id: 'white', hex: '#FFFFFF', name: 'White', border: '#E5E5E5' },
  { id: 'black', hex: '#1A1A1A', name: 'Black', border: '#1A1A1A' },
  { id: 'blue', hex: '#2563EB', name: 'Blue', border: '#2563EB' },
  { id: 'turquoise', hex: '#14B8A6', name: 'Turquoise', border: '#14B8A6' },
  { id: 'green', hex: '#22C55E', name: 'Green', border: '#22C55E' },
  { id: 'yellow', hex: '#EAB308', name: 'Yellow', border: '#EAB308' },
  { id: 'brown', hex: '#92400E', name: 'Brown', border: '#92400E' },
  { id: 'red', hex: '#EF4444', name: 'Red', border: '#EF4444' },
  { id: 'pink', hex: '#EC4899', name: 'Pink', border: '#EC4899' },
  { id: 'orange', hex: '#F97316', name: 'Orange', border: '#F97316' },
];

export const getColorHex = (colorId) => {
  const color = PIECE_COLORS.find(c => c.id === colorId);
  return color ? color.hex : '#FFFFFF';
};

export const ColorPicker = ({ selectedColor, onSelect, testIdPrefix = '' }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center gap-1 flex-wrap justify-center" data-testid={`${testIdPrefix}color-picker`}>
        {PIECE_COLORS.map((color) => {
          const isSelected = selectedColor === color.id;
          return (
            <Tooltip key={color.id}>
              <TooltipTrigger asChild>
                <button
                  onClick={() => onSelect(color.id)}
                  className={`w-6 h-6 rounded-sm transition-all ${
                    isSelected 
                      ? 'ring-2 ring-offset-1 ring-zinc-900 scale-110' 
                      : 'hover:scale-105'
                  }`}
                  style={{ 
                    backgroundColor: color.hex,
                    border: `2px solid ${color.border}`
                  }}
                  data-testid={`${testIdPrefix}color-${color.id}`}
                  aria-label={color.name}
                />
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">
                {color.name}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};
